import React from "react";

export default function ProfilePageContent({ children }) {
  return (
    <div className="avc-page">
      <div className="container">
        <div className="row">{children}</div>
      </div>
    </div>
  );
}
